import { AT_BOTTOM } from '@/lib/ai-chat-scroll';
import { ref } from 'vue';

const sessions = new Map();

const newSession = () => ({
  draft: ref(null),
  attachments: ref([]),
  scrollAnchor: ref(AT_BOTTOM),
  traces: ref({}),
});

export const clearSession = (chatId) => sessions.delete(chatId);

export const resetSessions = () => sessions.clear();

export default function useAiChatSession(chatId) {
  if (!sessions.has(chatId)) {
    sessions.set(chatId, newSession());
  }
  return sessions.get(chatId);
}
